const BANDS: { maxRating: number; letter: string; range: string }[] = [
  { maxRating: 600, letter: 'a', range: '< 600' },
  { maxRating: 800, letter: 'b', range: '600–799' },
  { maxRating: 1000, letter: 'c', range: '800–999' },
  { maxRating: 1300, letter: 'd', range: '1000–1299' },
  { maxRating: 1600, letter: 'e', range: '1300–1599' },
  { maxRating: 1900, letter: 'f', range: '1600–1899' },
  { maxRating: 2200, letter: 'g', range: '1900–2199' },
  { maxRating: Number.POSITIVE_INFINITY, letter: 'h', range: '2200+' },
];

export function ratingToBand(rating: number): string {
  return BANDS.find((band) => rating < band.maxRating)?.letter ?? 'h';
}

export function ratingBandRange(rating: number): string {
  return BANDS.find((band) => rating < band.maxRating)?.range ?? '2200+';
}

export function bandLetterRange(letter: string): string {
  return BANDS.find((band) => band.letter === letter)?.range ?? '';
}
